import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from 'App.context.js';
import DefaultLayout from 'Components/DefaultLayout/DefaultLayout.jsx';
import ContentBox from 'Components/common/ContentBox/ContentBox.jsx';
import AppSelector from 'Components/common/AppSelector/AppSelector';

import useIntegratedPlatformHook from './integratedPlatform.hook';
import PoliceSES from './PoliceSES/PoliceSES.jsx';
import PoliceERTZ from './PoliceERTZ/PoliceERTZ.jsx';
import PoliceMOSSOS from './PoliceMOSSOS/PoliceMOSSOS.jsx';
import PoliceAlloggiati from './PoliceAlloggiati/PoliceAlloggiati';

export default function IntegratedPlatform() {
  const { state, actions } = useIntegratedPlatformHook();
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const [selectedOption, setSelectedOption] = useState(state.platform || null);

  const platformOptions = [
    { label: translate('policeReport.ses.ses'), value: 'ses' },
    { label: translate('policeReport.ertz.ertz'), value: 'ertz' },
    { label: translate('policeReport.mossos.mossos'), value: 'mossos' },
    { label: translate('policeReport.alloggiati.alloggiati'), value: 'alloggiati' },
  ];

  useEffect(() => {
    if (state.platform) {
      setSelectedOption(state.platform);
    }
  }, [state.platform]);

  const handleSelect = option => {
    setSelectedOption(option);
  };

  const renderPlatform = () => {
    const platform = selectedOption ?? state.platform;

    switch (platform) {
      case 'ses':
        return <PoliceSES />;
      case 'ertz':
        return <PoliceERTZ />;
      case 'mossos':
        return <PoliceMOSSOS />;
      case 'alloggiati':
        return <PoliceAlloggiati />;
      default:
        return null;
    }
  };

  return (
    <DefaultLayout title={translate('layout.policeReportConfig')} enableAllHotels={false}>
      <ContentBox title={translate('policeReport.whoDoIReportTo')}>
        <AppSelector
          title={translate('Selecciona una plataforma')}
          value={selectedOption}
          options={platformOptions}
          onOptionSelected={handleSelect}
        />
        {renderPlatform()}
      </ContentBox>
    </DefaultLayout>
  );
}
